<template>
	<div>
		<div class="sm:flex items-center m-auto text-center sm:text-left mb-5">
			<h2>{{ $t("Autorisation l’accès pour assistance technique") }}</h2>
		</div>

		<vs-alert v-if="returnError" class="mt-3 mb-5" :title="returnError.title">
			{{ returnError.text }}
		</vs-alert>

		<vs-card v-if="invite" class="shadow-none border">
			<div class="vx-row mb-3">
				<div class="vx-col sm:w-1/2 w-full">
					<vs-input
						v-model="firstname"
						disabled
						name="prenom"
						color="var(--black)"
						class="w-full"
						:placeholder="$t('Prénom')"
						label-placeholder="Prénom"
					/>
				</div>
				<div class="vx-col sm:w-1/2 w-full">
					<vs-input
						v-model="lastname"
						disabled
						name="nom"
						color="var(--black)"
						class="w-full"
						:placeholder="$t('Nom')"
						label-placeholder="Nom"
					/>
				</div>
			</div>

			<div class="vx-row">
				<div class="vx-col w-full my-3">
					<vs-input
						:value="email"
						disabled
						name="email"
						color="var(--black)"
						class="w-full"
						:placeholder="$t('Email')"
					/>
				</div>
			</div>

			<!-- soumission du fomulaire -->
			<div class="vx-row pt-35">
				<div class="vx-coll w-1/2 px-3">
					<s-button type="border" class="w-full" @click="confirmeCancelInvit">
						{{ $t("Décliner l’invitation") }}
					</s-button>
				</div>

				<div class="vx-col w-1/2 px-3">
					<s-button ref="submit" type="success" class="w-full vs-con-loading__container" @click="validate">
						{{ $t("Accepter l’invitation") }}
					</s-button>
				</div>
			</div>
		</vs-card>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import i18n from "../i18n";

	export default {
		data() {
			return {
				invite: null,
				firstname: "",
				lastname: "",
				token: this.$route.params.tokenURL,
				app_id: this.$route.query.app_id || null,
				partner_id: this.$route.query.partner_id || null,
				returnError: null,
				apiErrors: {
					get: {
						404: {
							code: 404,
							title: i18n.t("L’invitation que vous essayez d’utiliser n’existe pas."),
							text: i18n.t(
								"Vérifiez que l’on vous a transmis le lien de cette invitation en entier et/ou que vous l’avez copié en entier."
							)
						},
						400: {
							code: 400,
							title: i18n.t("L’invitation que vous essayez d’utiliser n’est pas valide"),
							text: i18n.t("Vérifiez l’integrité du lien que vous avez suivi.")
						},
						default: {
							code: "default",
							title: i18n.t("Erreur inconnue"),
							text: i18n.t("Une erreur est survenue, veuillez nous excuser.")
						}
					},
					post: {
						400: {
							code: 400,
							title: i18n.t("Requete invalide"),
							text: i18n.t(
								"Une erreur est survenue, cela ne vivient propablement pas de vous, veuillez nous excuser."
							)
						},
						404: {
							code: 404,
							title: i18n.t("L’invitation que vous essayez d’utiliser n’existe plus."),
							text: i18n.t("Demander a ce que votre invitation soit renouvellée.")
						},
						401: {
							code: 401,
							title: i18n.t("L’invitation que vous essayez d’utiliser a expirée."),
							text: i18n.t("Demander a ce que votre invitation soit renouvellée.")
						},
						default: {
							code: "default",
							title: i18n.t("Erreur inconnue"),
							text: i18n.t("Une erreur est survenue, veuillez nous excuser.")
						}
					}
				}
			};
		},
		computed: {
			...mapGetters(["getImageUrl"])
		},
		async created() {
			try {
				this.invite = await this.$store.dispatch("getInvite", this.token);

				const expirationTimestamp = new Date(this.invite.created_at).getTime() + 30 * 24 * 60 * 60 * 1000;

				if (expirationTimestamp - new Date().getTime() <= 0) {
					this.getError("post", 401);
				}
			} catch (error) {
				this.getError("get", error?.response?.status);
			}

			if (this.invite) {
				const { firstname, lastname, email } = this.invite;

				this.firstname = firstname;
				this.lastname = lastname;
				this.email = email;
			}
		},
		methods: {
			getError(method, status) {
				this.returnError = this.apiErrors[method][status] ?? this.apiErrors[method]["default"];
			},
			async validate() {
				const { email, token } = this;

				this.$vs.loading({
					type: "default",
					color: "var(--white)",
					background: "var(--success)",
					container: this.$refs.submit.$el,
					scale: 0.5
				});

				this.$store
					.dispatch("acceptInviteSupport", {
						email,
						token,
						appId: this.app_id ? parseInt(this.app_id) : null,
						partnerId: this.partner_id ? parseInt(this.partner_id) : null
					})
					.then(() => {
						this.$vs.notify({
							title: i18n.t("Support Technique accepté !"),
							color: "success",
							iconPack: "feather",
							icon: "icon-check",
							time: 5000
						});

						this.$router.push({ path: "/", query: this.$route.query });
					})
					.catch(error => {
						console.log(error);
						this.$vs.loading.close(this.$refs.submit.$el);
						this.getError("post", error?.response?.status);
					});
			},
			cancel() {
				this.$store
					.dispatch("deleteInviteByToken", this.token)
					.then(() => {
						this.$router.push({ path: "/", query: this.$route.query });
					})
					.catch(error => {
						console.log(error);

						this.getError("post", error?.response?.status);
						this.$vs.notify({
							title: i18n.t("Impossible de rejeter l’invitation"),
							text: i18n.t("L’invitation n’a pas pu etre rejetée. Raison : ...", { error: error }),
							color: "success",
							iconPack: "feather",
							icon: "icon-check",
							time: 5000
						});
					});
			},
			goToLogin() {
				this.$router.push({ path: "/login" });
			},
			confirmeCancelInvit() {
				this.$vs.dialog({
					type: "confirm",
					title: i18n.t("Confirmer le rejet de l’invitation"),
					text: i18n.t("Etes vous sûr de vouloir Décliner l’invitation ?"),
					accept: () => this.cancel(),
					cancel: () => {},
					acceptText: i18n.t("Oui"),
					cancelText: i18n.t("Non")
				});
			}
		}
	};
</script>

<style>
	div.vs-card--content {
		padding: 35px !important;
	}

	.pb-35 {
		padding-bottom: 35px;
	}
	.pt-35 {
		padding-top: 35px;
	}
</style>
